const MODULE_URL = 'users';
export default {
  MODULE_URL: MODULE_URL,
  SEARCH_NICKS_URL: MODULE_URL + '/search_nicks',
  SEARCH_HINTED_USER_URL: MODULE_URL + '/search_hinted_user',

  IGNORES_URL: MODULE_URL + '/ignores',

  IGNORE_ADDED: 'ignored_user_added',
  IGNORE_REMOVED: 'ignored_user_removed',
};
